import { CurrencyPoundIcon } from "@heroicons/react/24/outline";
import { QuoteType } from "../../../../models/Lead";
import classNames from "../../../../utils/classNames";
import { GetQuoteType } from "../../LeadInformation/QuoteCalculationCard";

export default function PricingHeader({ quoteType }: { quoteType: QuoteType }) {
  return (
    <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
      <div className="flex items-center gap-2">
        <CurrencyPoundIcon className="h-5 w-5 text-gray-400" />
        <h3 className="text-sm font-semibold text-gray-900">Pricing Summary</h3>
      </div>

      <span
        className={classNames(
          "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold",
          quoteType === QuoteType.Salvage
            ? "bg-blue-100 text-blue-700"
            : quoteType === QuoteType.SmartPrice
              ? "bg-purple-100 text-purple-700"
              : "bg-gray-100 text-gray-700"
        )}
      >
        {GetQuoteType(quoteType)}
      </span>
    </div>
  );
}